import { defineStore } from 'pinia'
import { api } from '@/lib/api'

export interface User { id: string; name: string; email: string }
interface AuthState { user: User | null; ready: boolean; loading: boolean }

export const useAuth = defineStore('auth', {
    state: (): AuthState => ({ user: null, ready: false, loading: false }),

    getters: {
        isAuthenticated: (s) => !!s.user,
    },

    actions: {
        async ensureCsrf() {
            try { await api.get('/sanctum/csrf-cookie') } catch {}
        },

        // silent401=true => não propaga erro 401 (evita "Unexpected error when starting the router")
        async fetchUser(opts: { silent401?: boolean } = { silent401: true }) {
            this.loading = true
            try {
                const { data } = await api.get('/api/user')
                this.user = data ?? null
                return this.user
            } catch (e: any) {
                if (opts.silent401 && e?.response?.status === 401) {
                    this.user = null
                    return null
                }
                throw e
            } finally {
                this.loading = false
                this.ready = true
            }
        },

        async login(email: string, password: string) {
            this.loading = true
            try {
                await this.ensureCsrf()
                await api.post('api/auth/login', { email, password /*, remember: true */ })
                await this.fetchUser({ silent401: false })
            } finally { this.loading = false }
        },

        async logout() {
            this.loading = true
            try { await api.post('/logout') }
            finally {
                this.user = null
                this.loading = false
            }
        },
    },

    // lembrete: só funciona se você tiver o plugin pinia-plugin-persistedstate
    persist: { key: 'auth', storage: localStorage, pick: ['user'] },
})
